import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Input, Label } from 'reactstrap';
import { useField } from 'formik';

const FormCompanyName = (props) => {
  const [filed, meta] = useField(props)

  return (
    <div className="page-block page-block_border">
      <FormGroup className="form-group">
          <Label for="onboarding-company-name">Company name <sup>*</sup></Label>
          <div className="input-wrapper">
            <Input
              id="onboarding-company-name"
              name={props.name}
              {...filed}
              {...props}
            />
            <div className="domen">.hubbleiq.net</div>
          </div>
          {meta.touched && meta.error && <div className="invalid-feedback">{meta.error}</div>}
      </FormGroup>
    </div>
  );
};

FormCompanyName.propTypes = {
  companyName: PropTypes.string,
  setCompanyName: PropTypes.func,
  setCanGo: PropTypes.func,
};

export default FormCompanyName;
